// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { CommonProperties } from '@internal/acs-ui-common';
import { ChatHandlers } from '@internal/chat-component-bindings';
import { ReactElement } from 'react';
import memoizeOne from 'memoize-one';
import { ChatAdapter } from '../adapter/ChatAdapter';
import { useAdapter } from '../adapter/ChatAdapterProvider';
/**
 * @private
 */
export const useHandlers = <PropsT,>(_component: (props: PropsT) => ReactElement | null): Pick<ChatHandlers, CommonProperties<ChatHandlers, PropsT>> => {
  return createCompositeHandlers(useAdapter());
};
const createCompositeHandlers = memoizeOne((adapter: ChatAdapter): ChatHandlers => ({
  // have to use `any` here so we don't import from Chat SDK
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSendMessage: (content: string, options: any) => {
    return adapter.sendMessage(content, options);
  },
  onLoadPreviousChatMessages: adapter.loadPreviousChatMessages,
  onMessageSeen: adapter.sendReadReceipt,
  onTyping: adapter.sendTypingIndicator,
  onRemoveParticipant: adapter.removeParticipant,
  updateThreadTopicName: adapter.setTopic,
  onUpdateMessage: function (messageId: string, content: string) {
    return adapter.updateMessage(messageId, content);
  },
  onDeleteMessage: adapter.deleteMessage
}));